export function toCurrency(value) {
	if (typeof value !== "number") {
		return value;
	}
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	}).format(value);
}

export function formatCell(n) {
	if (n == null || n === "") return "-";
	const num = Number(n);
	return Number.isFinite(num) ? num.toLocaleString() : String(n);
}

export function formatNum(n) {
	return Number(n || 0).toLocaleString();
}

export function formatMoney(n) {
	if (n == null || n === "") return "-";
	const val = Number(n);
	if (!Number.isFinite(val)) return String(n);
	return val >= 1000 ? "$" + val.toLocaleString(undefined, { maximumFractionDigits: 0 }) : "$" + val.toFixed(2);
}

/** CR display — matches admin lib.common.numericFmt (3 decimal places). */
export function formatCr(v) {
	if (v == null || v === "") return "-";
	const num = Number(v);
	if (!Number.isFinite(num)) return String(v);
	return Math.round(num * 1000) / 1000;
}

export async function copyToClipboard(text) {
	await navigator.clipboard.writeText(text);
}
